var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingIconFilledGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F4F7F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6515 3.33337V3.34673V4.68206C13.5854 5.0426 15.6639 7.7066 15.303 10.6377C14.9955 13.068 13.0841 14.9975 10.6515 15.2846V16.62C14.3272 16.2528 17.0005 12.9945 16.6329 9.32236C16.3322 6.15093 13.8126 3.64718 10.6515 3.33337ZM9.31483 3.3534C8.01161 3.48026 6.76853 3.98101 5.75269 4.82227L6.70838 5.81042C7.4569 5.20952 8.35913 4.82227 9.31483 4.68874V3.3534ZM4.81036 5.76369C3.96828 6.77854 3.46704 8.01373 3.33337 9.32236H4.67001C4.79699 8.37427 5.17125 7.47292 5.76605 6.71845L4.81036 5.76369ZM12.3223 7.65319L9.06087 10.9114L7.64403 9.49595L6.93561 10.2037L9.06087 12.3269L13.0307 8.36092L12.3223 7.65319ZM3.34006 10.6577C3.47372 11.9663 3.98833 13.2015 4.81704 14.2164L5.76605 13.2616C5.17793 12.5071 4.79699 11.6058 4.67669 10.6577H3.34006ZM6.70838 14.2431L5.75269 15.1578C6.76185 15.999 8.00492 16.5265 9.31483 16.6667V15.3314C8.36581 15.2112 7.46358 14.8306 6.70838 14.2431Z",
    fill: "#9FA3AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIconFilledGray);
export default __webpack_public_path__ + "static/media/PendingIconFilledGray.d2c3d588e033d8c7c045ebca26702546.svg";
export { ForwardRef as ReactComponent };